/**
 * @description Defines the available selection behaviors for the tree component.
 */
export enum TreeSelectionMode {
    /** @description Only a single node can be selected at a time. */
    Single = 'single',

    /** @description Multiple nodes can be selected independently. */
    Multiple = 'multiple',

    /** @description Selection uses checkboxes with parent/child cascade logic. */
    Checkbox = 'checkbox'
}

/**
 * @description How the user may select nodes in the tree.
 */
export type ITreeSelectionMode = 'single' | 'multiple' | 'checkbox';